<template>
  <div class="bg-blue-grey-10">
    <q-expansion-item
      v-if="menuItem.children && menuItem.children.length > 0"
      :label="menuItem.title"
      :icon="displayIcon(menuItem.icon)"
      :target="getItemTarget"
      :to="menuItem.url"
      :switch-toggle-side="switchToggleSide"
      :dense="switchToggleSide"
      :group="menuItem.icon ? 'outer' : 'inner'"
      :active-class="activeClass"
      :default-opened="isActive"
      :header-class="isActive ? activeClass : ''"
      expand-separator
      tag="a"
    >
      <q-card v-if="menuItem.children && menuItem.children.length > 0">
        <SystemMenuItems
          v-for="child in menuItem.children"
          :key="child.title"
          :menu-item="child"
          switch-toggle-side
        />
      </q-card>
    </q-expansion-item>
    <q-item
      v-else
      :href="getItemHref"
      :target="getItemTarget"
      :to="getItemTo"
      :inset-level="inset"
      :active-class="activeClass"
      clickable
      dense
      tag="a"
    >
      <q-item-section v-if="menuItem.icon || true" avatar>
        <q-icon :name="displayIcon(menuItem.icon)" />
      </q-item-section>

      <q-item-section>
        <q-item-label>{{ menuItem.title }}</q-item-label>
      </q-item-section>
    </q-item>
    <q-separator />
  </div>
</template>

<script setup>
  const props = defineProps({
    menuItem: {
      type: Object,
      required: true,
    },
    activeClass: {
      type: String,
      default: "bg-primary text-yellow",
    },
    inset: {
      type: Number,
      default: 0,
    },
    switchToggleSide: {
      type: Boolean,
      default: false,
    },
  });

  const route = useRoute();

// Helper Methods
const displayIcon = (icon) => {
  switch (icon) {
    case "sign-out":
      return "fas fa-sign-out-alt";

    case "clock-o":
      return "fas fa-clock";

    case "qr_code_scanner":
    case "add_to_queue":
    case "settings":
    case "print":
    case "refresh":
      return icon;
      
    default:
      return icon ? `fa fa-${icon}` : undefined;
  }
};
const isActive = computed(() => {
  return route.path.match("/" + props.menuItem.active_flag) !== null;
});
const convertToNuxtRoute = (originalRouteName) => {
  // Complete route name change
  switch(originalRouteName) {
    case 'corrections.attendance':
      return { name: 'attendance-corrections' };

    case 'courserecommendations.manage':
      return { name: 'courserecs-index' };

    case 'jc.manage':
      return { name: 'jobcoach-admin' };
      
    case 'leydenmobile.students.search':
      return { name: 'mobile-students' };
      
    case 'leydenmobile.staff.search':
      return { name: 'mobile-staff' };
      
    case 'leydenmobile.rooms.search':
      return { name: 'mobile-rooms' };
      
    case 'lhac.hac':
      return { name: 'lhac' };
      
    case 'mtss.lookup':
      return { name: 'mtss' };
      
    case 'scanning.dashboard':
      return { name: 'scanning-reports' };

    case 'schoology.start':
      return { name: 'schoology' };

    case 'teaching.substitute':
      return { name: 'sub' };
      
    case 'techloaner.equipments':
      return { name: 'techloaner-equipment' };
      
    case 'tools.google.redirect':
      return { name: 'tools-google' };
  }

  // Simple formatting change
  const routeName = originalRouteName
    .replace('.dashboard', '')
    .replace('leydenmobile.', 'mobile-')
    .replace('jc.', 'jobcoach-')
    .replaceAll('.', '-');
  return { name: routeName };
}
const getItemTo = computed(() => {
  if (props.menuItem.vue_route_name) {
    return convertToNuxtRoute(props.menuItem.vue_route_name);
  }
  if (typeof props.menuItem.url !== "string") {
    return props.menuItem.url;
  }
  return `/${props.menuItem.url}`;
});
const getItemHref = computed(() => {
  if (props.menuItem.vue_route_name) {
    return undefined;
  }
  if (typeof props.menuItem.url === "string") {
    return props.menuItem.url;
  }

  return undefined;
});
const getItemTarget = computed(() => {
  if (props.menuItem.vue_route_name) {
    return undefined;
  }
  if (
    typeof props.menuItem.url === "string" &&
    props.menuItem.url.substring(4) === "http"
  ) {
    return "_blank";
  }

  return undefined;
});
</script>

<style>

</style>